var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.715,
    height: 16.941,
    viewBox: "0 0 26.715 16.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M17.161,32.471,9,37.784V27.157Zm10.393,0,8.161,5.314V27.157Zm-1.192.779-3.649,2.375a.657.657,0,0,1-.71,0l-3.649-2.375L9.541,38.987l-.512.332a1.959,1.959,0,0,0,1.925,1.622H33.761a1.956,1.956,0,0,0,1.925-1.622l-.515-.332Zm-4,1.049,12.814-8.344.515-.332A1.956,1.956,0,0,0,33.761,24H10.955a1.959,1.959,0,0,0-1.925,1.622l.512.332Z",
    transform: "translate(-9 -24)",
    fill: "#fe6831"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOrange);
export default __webpack_public_path__ + "static/media/email-orange.d88bc72f1af744cfcab81c240a108e08.svg";
export { ForwardRef as ReactComponent };